import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router';
import { Card, Heading, useToast } from '@skf-internal/ui-components-react-legacy';
import ManufacturerForm from './ManufacturerForm';
import { createManufacturer, CreateManufacturerDto } from 'services/api/master-data.service';

const AddManufacturerPage = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { addToast } = useToast();
  const initialValues: CreateManufacturerDto = {
    manufacturerName: '',
    originalSourceName: '',
    sWtg: '',
    wtg: '',
    gearbox: '',
    generator: '',
    country: '',
    websiteLink: '',
    remark: ''
  };

  const handleSubmit = async (values: CreateManufacturerDto) => {
    try {
      await createManufacturer(values);
      addToast({ children: intl.formatMessage({ id: 'masterdata.manufacturer.add.success' }), feSeverity: 'success' });
      // Redirect to the manufacturer list page after successful creation
      navigate('/master-data/manufacturers');
    } catch (error: any) {
      addToast({ children: intl.formatMessage({ id: 'masterdata.manufacturer.add.failure' }, { message: error.message }), feSeverity: 'error' });
    }
  };

  const handleCancel = () => {
    navigate('/master-data/manufacturers');
  };

  return (
    <Card className="mb-5">
      <Heading as={'h1'} className="mb-4">
        {intl.formatMessage({ id: 'masterdata.manufacturer.add.heading' })}
      </Heading>
      <ManufacturerForm initialValues={initialValues} onSubmit={handleSubmit} onCancel={handleCancel} />
    </Card>
  );
};

export default AddManufacturerPage;
